import React from "react";
import CssBaseline from "@mui/material/CssBaseline";

import AppShell from "../appShell/appShell";

// This used to be a 280px MUI Drawer plus a separate AppBar. It is now a thin
// wrapper over AppShell, which draws the dark icon rail, the top bar and the
// rounded content panel.
//
// The name and props are kept because 22 pages import this component; nothing
// at the call sites had to change. `show` / `setshow` are still accepted and
// ignored, as they were only ever read by the old drawer's mobile toggle.
export default function ResponsiveDrawer({ children, bare }) {
  return (
    <>
      <CssBaseline />
      <AppShell bare={bare}>{children}</AppShell>
    </>
  );
}
